import UserMenu from './UserMenu';
import UserDropdownMenuContainer from './UserMenu.container';
export default UserDropdownMenuContainer(UserMenu);
//# sourceMappingURL=index.js.map